import LabelRequired from "../LabelRequired";
import styles from "./FieldFormRequired.module.css"

function FieldFormRequired({ field, type, placeholder, setThing, value }) {
    return (
        <div className={styles.container}>
            <LabelRequired>
                {field}
            </LabelRequired>
            <input
                type={type}
                placeholder={placeholder}
                id={field}
                onChange={(e) => {
                    setThing(e.target.value)
                }}
                required
                value={value}
            />
        </div>
    )
}

export default FieldFormRequired;